import { useLocation, useHistory } from "react-router-dom";
import { get } from "lodash";
import PageNotFound from "../../pages/errorPages/PageNotFound";
import { useQueryClient } from "react-query";
import InternalServerError from "../../pages/errorPages/InternalServerError";
import DevAuthAPI from "../../api/DevAuth";
import ConsoleLocalStorage from "../../storage/storage";

const ErrorHandler = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    let api = new DevAuthAPI();
    if(ConsoleLocalStorage.getRememberMe() === "true"){
      api.refreshToken({"refreshToken":ConsoleLocalStorage.getRefreshToken()}).then((response)=>{
          ConsoleLocalStorage.setAccessToken(response.data.data.access_token);
          ConsoleLocalStorage.setRefreshToken(response.data.data.refresh_token);
          history.replace(history.location.pathname, {
            errorStatusCode: 200,
          });
      });
    }else{
      ConsoleLocalStorage.clearStorageExceptFTU();
      // localStorage.clear();
      queryClient.invalidateQueries();
      history.push("/login");
    }
  };

  switch (get(location.state, "errorStatusCode")) {
    case 404:
      return <PageNotFound />;
    case 400:
      return <PageNotFound />;
    case 500:
      return <InternalServerError />;
    case 401:
      handleLogout();
    default:
      return children;
  }
};

export default ErrorHandler;
